export const ERRORS_MESSAGE = {
    SERVICE_SERVER_ERROR: 'Data incorrect',
    BAD_REQUEST: 'Error. Try again',
    DNS_RECORD_EXIST: 'Record exist',
    EMPTY_DATA: 'There is no data',
    NAMESERVER_EXIST: 'Nameserver already exist',
    OLD_PASSWORD_NOT_MATCH: 'Your password is wrong',
};

export const ERRORS = {
    SERVICE_SERVER_ERROR: 'SERVICE_SERVER_ERROR',
    BAD_REQUEST: 'BAD_REQUEST',
    DNS_RECORD_EXIST: 'DNS_RECORD_EXIST',
    NAMESERVER_EXIST: 'NAMESERVER_EXIST',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    REFRESH_TOKEN_INVALID: 'REFRESH_TOKEN_INVALID',
    EMAIL_FORWARDING_RECORD_EXIST: 'EMAIL_FORWARDING_RECORD_EXIST',
    EMAIL_TYPE_NOT_SUPPORT: 'EMAIL_TYPE_NOT_SUPPORT',
    EMAIL_FORWARDING_MAX: 'EMAIL_FORWARDING_MAX',
    EMAIL_FORWARDING_NOT_EXIST: 'EMAIL_FORWARDING_NOT_EXIST',
    DNS_NOT_FOUND: 'DNS_NOT_FOUND',
    EMAIL_EXISTS: 'EMAIL_EXISTS',
    OLD_PASSWORD_NOT_MATCH: 'OLD_PASSWORD_NOT_MATCH',
    SERVICE_UNAVAILABLE_TO_RENEW: 'SERVICE_UNAVAILABLE_TO_RENEW',
    SERVICE_CAN_NOT_UPGRADE: 'SERVICE_CAN_NOT_UPGRADE',
    BRAND_NAME_IS_NOT_ASSIGNED: 'BRAND_NAME_IS_NOT_ASSIGNED',
    ACCOUNT_BANNED: 'ACCOUNT_BANNED',
    USER_HAS_BEEN_BANNED: 'USER_HAS_BEEN_BANNED',
    USERNAME_PASSWORD_INCORRECT: 'USERNAME_PASSWORD_INCORRECT',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    INVALID_2FA_CODE: 'INVALID_2FA_CODE',
    FAILED_PROGRESS: 'FAILED_PROGRESS',
    INCORRECT_PASSWORD: 'INCORRECT_PASSWORD',
    DOMAIN_CANNOT_REACTIVATED: 'DOMAIN_CANNOT_REACTIVATED',
    EMAIL_EXIST: 'EMAIL_EXIST',
    INCORRECT_OTP: 'INCORRECT_OTP',
};
